import React from 'react';

import { Icon } from '../icons';

export const ChevronLeftIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M4.35244493,15.1501328 L19.0301515,0.35244493 C19.5000781,-0.117481643 20.2599594,-0.117481643 20.729886,0.35244493 L22.7095766,2.3321356 C23.1795032,2.80206218 23.1795032,3.56194345 22.7095766,4.03187002 L10.8614279,16 L22.7095766,27.96813 C23.1795032,28.4380566 23.1795032,29.1979378 22.7095766,29.6678644 L20.729886,31.6475551 C20.2599594,32.1174816 19.5000781,32.1174816 19.0301515,31.6475551 L4.35244493,16.8498672 C3.88251836,16.3799406 3.88251836,15.6200594 4.35244493,15.1501328 Z" />
    </svg>
  );
};
